import { theme as baseTheme } from '@chakra-ui/react'

export const appColors = {
  ...baseTheme.colors,

  blue: {
    '50': 'var(--color-blue-50)',
    '100': 'var(--color-blue-100)',
    '200': 'var(--color-blue-200)',
    '300': 'var(--color-blue-300)',
    '400': 'var(--color-blue-400)',
    '500': 'var(--color-blue-500)',
    '600': 'var(--color-blue-600)',
    '700': 'var(--color-blue-700)',
    '800': 'var(--color-blue-800)',
    '900': 'var(--color-blue-900)',
  },

  gray: {
    '100': 'var(--color-gray-100)',
    '200': 'var(--color-gray-200)',
    '300': 'var(--color-gray-300)',
    '400': 'var(--color-gray-400)',
    '500': 'var(--color-gray-500)',
    '600': 'var(--color-gray-600)',
    '700': 'var(--color-gray-700)',
    '800': 'var(--color-gray-800)',
    '900': 'var(--color-gray-900)',
  },

  yellow: {
    '100': 'var(--color-yellow-100)',
    '200': 'var(--color-yellow-200)',
    '300': 'var(--color-yellow-300)',
    '400': 'var(--color-yellow-400)',
    '500': 'var(--color-yellow-500)',
    '600': 'var(--color-yellow-600)',
    '700': 'var(--color-yellow-700)',
    '800': 'var(--color-yellow-800)',
    '900': 'var(--color-yellow-900)',
  },

  // Tailwind Colors (excluding blue)
  red: {
    '50': 'var(--color-red-50)',
    '100': 'var(--color-red-100)',
    '200': 'var(--color-red-200)',
    '300': 'var(--color-red-300)',
    '400': 'var(--color-red-400)',
    '500': 'var(--color-red-500)',
    '600': 'var(--color-red-600)',
    '700': 'var(--color-red-700)',
    '800': 'var(--color-red-800)',
    '900': 'var(--color-red-900)',
  },

  orange: {
    '50': 'var(--color-orange-50)',
    '300': 'var(--color-orange-300)',
    '400': 'var(--color-orange-400)',
    '500': 'var(--color-orange-500)',
    '600': 'var(--color-orange-600)',
    '700': 'var(--color-orange-700)',
    '800': 'var(--color-orange-800)',
    '900': 'var(--color-orange-900)',
  },

  amber: {
    '50': 'var(--color-amber-50)',
    '100': 'var(--color-amber-100)',
    '200': 'var(--color-amber-200)',
    '300': 'var(--color-amber-300)',
    '400': 'var(--color-amber-400)',
    '500': 'var(--color-amber-500)',
    '600': 'var(--color-amber-600)',
    '700': 'var(--color-amber-700)',
    '800': 'var(--color-amber-800)',
    '900': 'var(--color-amber-900)',
    '950': 'var(--color-amber-950)',
  },

  lime: {
    '50': 'var(--color-lime-50)',
    '400': 'var(--color-lime-400)',
    '500': 'var(--color-lime-500)',
    '600': 'var(--color-lime-600)',
    '900': 'var(--color-lime-900)',
  },

  green: {
    '50': 'var(--color-green-50)',
    '100': 'var(--color-green-100)',
    '200': 'var(--color-green-200)',
    '300': 'var(--color-green-300)',
    '400': 'var(--color-green-400)',
    '500': 'var(--color-green-500)',
    '600': 'var(--color-green-600)',
    '700': 'var(--color-green-700)',
    '800': 'var(--color-green-800)',
    '900': 'var(--color-green-900)',
    '950': 'var(--color-green-950)',
  },

  emerald: {
    '500': 'var(--color-emerald-500)',
  },

  teal: {
    '50': 'var(--color-teal-50)',
    '300': 'var(--color-teal-300)',
    '400': 'var(--color-teal-400)',
    '500': 'var(--color-teal-500)',
    '600': 'var(--color-teal-600)',
    '700': 'var(--color-teal-700)',
    '800': 'var(--color-teal-800)',
    '900': 'var(--color-teal-900)',
  },

  cyan: {
    '900': 'var(--color-cyan-900)',
  },

  sky: {
    '300': 'var(--color-sky-300)',
    '500': 'var(--color-sky-500)',
  },

  violet: {
    '50': 'var(--color-violet-50)',
    '300': 'var(--color-violet-300)',
    '400': 'var(--color-violet-400)',
    '500': 'var(--color-violet-500)',
    '600': 'var(--color-violet-600)',
    '700': 'var(--color-violet-700)',
    '800': 'var(--color-violet-800)',
    '900': 'var(--color-violet-900)',
  },

  purple: {
    '50': 'var(--color-purple-50)',
    '300': 'var(--color-purple-300)',
    '400': 'var(--color-purple-400)',
    '500': 'var(--color-purple-500)',
    '600': 'var(--color-purple-600)',
    '700': 'var(--color-purple-700)',
    '800': 'var(--color-purple-800)',
    '900': 'var(--color-purple-900)',
  },

  pink: {
    '500': 'var(--color-pink-500)',
    '600': 'var(--color-pink-600)',
  },

  rose: {
    '50': 'var(--color-rose-50)',
    '300': 'var(--color-rose-300)',
    '400': 'var(--color-rose-400)',
    '500': 'var(--color-rose-500)',
    '600': 'var(--color-rose-600)',
    '700': 'var(--color-rose-700)',
    '800': 'var(--color-rose-800)',
    '900': 'var(--color-rose-900)',
  },

  slate: {
    '50': 'var(--color-slate-50)',
    '100': 'var(--color-slate-100)',
    '200': 'var(--color-slate-200)',
    '400': 'var(--color-slate-400)',
    '500': 'var(--color-slate-500)',
    '800': 'var(--color-slate-800)',
    '900': 'var(--color-slate-900)',
    '950': 'var(--color-slate-950)',
  },

  zinc: {
    '50': 'var(--color-zinc-50)',
    '100': 'var(--color-zinc-100)',
    '200': 'var(--color-zinc-200)',
    '400': 'var(--color-zinc-400)',
    '500': 'var(--color-zinc-500)',
    '800': 'var(--color-zinc-800)',
    '900': 'var(--color-zinc-900)',
    '950': 'var(--color-zinc-950)',
  },

  neutral: {
    '50': 'var(--color-neutral-50)',
    '100': 'var(--color-neutral-100)',
    '200': 'var(--color-neutral-200)',
    '300': 'var(--color-neutral-300)',
    '400': 'var(--color-neutral-400)',
    '500': 'var(--color-neutral-500)',
    '600': 'var(--color-neutral-600)',
    '700': 'var(--color-neutral-700)',
    '800': 'var(--color-neutral-800)',
    '900': 'var(--color-neutral-900)',
    '950': 'var(--color-neutral-950)',
  },

  stone: {
    '50': 'var(--color-stone-50)',
    '100': 'var(--color-stone-100)',
    '200': 'var(--color-stone-200)',
    '300': 'var(--color-stone-300)',
    '400': 'var(--color-stone-400)',
    '500': 'var(--color-stone-500)',
    '600': 'var(--color-stone-600)',
    '700': 'var(--color-stone-700)',
    '800': 'var(--color-stone-800)',
    '900': 'var(--color-stone-900)',
    '950': 'var(--color-stone-950)',
  },

  fuchsia: {
    '100': 'var(--color-fuchsia-100)',
    '200': 'var(--color-fuchsia-200)',
    '300': 'var(--color-fuchsia-300)',
    '400': 'var(--color-fuchsia-400)',
    '500': 'var(--color-fuchsia-500)',
    '600': 'var(--color-fuchsia-600)',
    '700': 'var(--color-fuchsia-700)',
    '800': 'var(--color-fuchsia-800)',
    '900': 'var(--color-fuchsia-900)',
  },

  // Base colors
  black: 'var(--color-black)',
  white: 'var(--color-white)',

  // Semantic tokens (shadcn-based)
  background: 'var(--color-background)',
  foreground: 'var(--color-foreground)',
  primary: 'var(--color-primary)',
  primaryForeground: 'var(--color-primary-foreground)',
  secondary: 'var(--color-secondary)',
  secondaryForeground: 'var(--color-secondary-foreground)',
  muted: 'var(--color-muted)',
  mutedForeground: 'var(--color-muted-foreground)',
  accent: 'var(--color-accent)',
  accentPrimary: 'var(--color-accent-primary)',
  accentSecondary: 'var(--color-accent-secondary)',
  border: 'var(--color-border)',
  borderHover: 'var(--color-border-hover)',
  intelligence: 'var(--color-intelligence)',
  positive: 'var(--color-positive)',
  negative: 'var(--color-negative)',
  warning: 'var(--color-warning)',
  info: 'var(--color-info)',

  // Legacy colors (for backward compatibility)
  brand: {
    primary: 'var(--color-primary-800)', // Keep existing usage working
  },
  status: {
    // TODO: Check if remove.
    error: {
      '50': 'var(--color-red-50)',
    },
  },
}
